// Aggiungi questo riferimento nel tuo file theme.liquid prima del tag </body>:
// {{ 'video-popup-mobile.js' | asset_url | script_tag }}

document.addEventListener('DOMContentLoaded', function() {
  // Funzione per verificare se il dispositivo è mobile
  function isMobileDevice() {
    return (window.innerWidth <= 767) || 
           (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  }
  
  // Crea il popup video
  if (!document.getElementById('fixedVideoPopup')) {
    // Crea l'HTML del popup
    var popupHTML = `
      <div id="fixedVideoPopup" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.85); z-index: 999999; justify-content: center; align-items: center;">
        <div id="videoPopupContainer" style="position: relative; width: 90%; max-width: 900px; max-height: 90vh;">
          <button id="fixedVideoPopupClose" style="position: absolute; top: -40px; right: 0; background: transparent; border: none; color: white; font-size: 30px; cursor: pointer;">&times;</button>
          <div id="fixedVideoPopupContent" style="position: relative; padding-bottom: 56.25%; height: 0; background: #000; overflow: hidden;">
            <!-- Video sarà inserito qui -->
          </div>
        </div>
      </div>
    `;
    
    // Aggiungi il popup al body
    document.body.insertAdjacentHTML('beforeend', popupHTML);
    
    // Aggiungi event listener per chiudere il popup
    document.getElementById('fixedVideoPopupClose').addEventListener('click', function() {
      var popup = document.getElementById('fixedVideoPopup');
      popup.style.display = 'none';
      document.getElementById('fixedVideoPopupContent').innerHTML = '';
      // Ripristina lo scroll
      document.body.style.overflow = '';
    });
    
    // Chiudi il popup quando si clicca fuori dal contenuto
    document.getElementById('fixedVideoPopup').addEventListener('click', function(e) {
      if (e.target === this) {
        this.style.display = 'none';
        document.getElementById('fixedVideoPopupContent').innerHTML = '';
        // Ripristina lo scroll
        document.body.style.overflow = '';
      }
    });
  }
  
  // Variabile per tracciare gli elementi video originali
  var originalVideoElements = [];
  
  // Funzione per richiedere la modalità fullscreen
  function requestFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) { /* Safari */
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) { /* IE11 */
      element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) { /* Firefox */
      element.mozRequestFullScreen();
    }
  }
  
  // Funzione per aprire il popup video e gestire il video originale
  function openFixedVideoPopup(videoContainer, event) {
    // Previeni l'evento predefinito per impedire l'avvio del video originale
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // Trova e metti in pausa qualsiasi video nella griglia
    pauseAllGridVideos();
    
    var popup = document.getElementById('fixedVideoPopup');
    var popupContent = document.getElementById('fixedVideoPopupContent');
    var popupContainer = document.getElementById('videoPopupContainer');
    
    // Imposta lo stile del container per mobile
    if (isMobileDevice()) {
      popupContainer.style.width = '100%';
      popupContainer.style.maxWidth = '100%';
      popupContainer.style.height = '100vh';
      popupContainer.style.maxHeight = '100vh';
      popupContent.style.height = '100%';
      popupContent.style.paddingBottom = '0';
    } else {
      // Ripristina gli stili per desktop
      popupContainer.style.width = '90%';
      popupContainer.style.maxWidth = '900px';
      popupContainer.style.height = 'auto';
      popupContainer.style.maxHeight = '90vh';
      popupContent.style.height = '0';
      popupContent.style.paddingBottom = '56.25%';
    }
    
    // Pulisci il contenuto esistente
    popupContent.innerHTML = '';
    
    // Blocca lo scroll della pagina sottostante
    document.body.style.overflow = 'hidden';
    
    // Trova elementi video
    var video = videoContainer.querySelector('video');
    var iframe = videoContainer.querySelector('iframe');
    var deferredMedia = videoContainer.querySelector('.deferred-media');
    
    // Per video HTML5 nativi
    if (video) {
      var videoClone = video.cloneNode(true);
      videoClone.controls = true;
      videoClone.autoplay = true;
      videoClone.muted = false;
      videoClone.playsInline = !isMobileDevice(); // Non usare playsinline su mobile per favorire fullscreen
      
      if (isMobileDevice()) {
        videoClone.style.position = 'absolute';
        videoClone.style.top = '0';
        videoClone.style.left = '0';
        videoClone.style.width = '100%';
        videoClone.style.height = '100%';
        videoClone.style.objectFit = 'contain';
      } else {
        videoClone.style.position = 'absolute';
        videoClone.style.top = '0';
        videoClone.style.left = '0';
        videoClone.style.width = '100%';
        videoClone.style.height = '100%';
      }
      
      popupContent.appendChild(videoClone);
      
      // Salva e pausa il video originale
      originalVideoElements.push({element: video, type: 'video'});
      video.pause();
      
      // Su mobile, richiedi la modalità fullscreen dopo un breve ritardo
      if (isMobileDevice()) {
        videoClone.addEventListener('playing', function oncePlay() {
          // Rimuovi questo listener per eseguirlo solo una volta
          videoClone.removeEventListener('playing', oncePlay);
          
          setTimeout(function() {
            try {
              requestFullscreen(videoClone);
            } catch(e) {
              console.log('Fullscreen request failed', e);
            }
          }, 200);
        });
      }
    } 
    // Per video iframe (YouTube/Vimeo)
    else if (iframe) {
      var src = iframe.src;
      
      // Aggiungi parametri di autoplay e fullscreen per mobile
      if (src.includes('youtube') || src.includes('youtu.be')) {
        // YouTube params
        src = src.includes('?') ? src + '&autoplay=1&mute=0' : src + '?autoplay=1&mute=0';
        
        // Se mobile, aggiungi parametri per favorire fullscreen
        if (isMobileDevice()) {
          src += '&playsinline=0&fs=1';
        }
      } else if (src.includes('vimeo')) {
        // Vimeo params
        src = src.includes('?') ? src + '&autoplay=1&muted=0' : src + '?autoplay=1&muted=0';
        
        // Se mobile, aggiungi parametri per favorire fullscreen
        if (isMobileDevice()) {
          src += '&playsinline=0&fullscreen=1';
        }
      }
      
      var iframeClone = document.createElement('iframe');
      iframeClone.src = src;
      iframeClone.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
      iframeClone.allowFullscreen = true;
      iframeClone.style.position = 'absolute';
      iframeClone.style.top = '0';
      iframeClone.style.left = '0';
      iframeClone.style.width = '100%';
      iframeClone.style.height = '100%';
      iframeClone.style.border = 'none';
      
      popupContent.appendChild(iframeClone);
      
      // Salva il riferimento all'iframe originale
      originalVideoElements.push({element: iframe, type: 'iframe', src: iframe.src});
      
      // Imposta l'iframe originale su blank o rimuovilo temporaneamente
      iframe.src = 'about:blank';
    } 
    // Per video in deferred media (comune per YouTube in Shopify)
    else if (deferredMedia) {
      var template = deferredMedia.querySelector('template');
      if (template) {
        var content = template.content.cloneNode(true);
        var templateIframe = content.querySelector('iframe');
        
        if (templateIframe) {
          var src = templateIframe.src || templateIframe.dataset.src;
          
          // Aggiungi parametri autoplay e fullscreen
          if (src.includes('youtube') || src.includes('youtu.be')) {
            src = src.includes('?') ? src + '&autoplay=1&mute=0' : src + '?autoplay=1&mute=0';
            
            // Se mobile, aggiungi parametri per favorire fullscreen
            if (isMobileDevice()) {
              src += '&playsinline=0&fs=1';
            }
          } else if (src.includes('vimeo')) {
            src = src.includes('?') ? src + '&autoplay=1&muted=0' : src + '?autoplay=1&muted=0';
            
            // Se mobile, aggiungi parametri per favorire fullscreen
            if (isMobileDevice()) {
              src += '&playsinline=0&fullscreen=1';
            }
          }
          
          templateIframe.src = src;
          templateIframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
          templateIframe.allowFullscreen = true;
          templateIframe.style.position = 'absolute';
          templateIframe.style.top = '0';
          templateIframe.style.left = '0';
          templateIframe.style.width = '100%';
          templateIframe.style.height = '100%';
          templateIframe.style.border = 'none';
          
          popupContent.appendChild(templateIframe);
          
          // Salva il riferimento al deferred media
          originalVideoElements.push({element: deferredMedia, type: 'deferred'});
        }
      }
    }
    
    // Mostra il popup
    popup.style.display = 'flex';
  }
  
  // Funzione per mettere in pausa tutti i video nella griglia
  function pauseAllGridVideos() {
    // Pausa tutti i video HTML5
    var allVideos = document.querySelectorAll('.product-gallery video');
    allVideos.forEach(function(video) {
      if (video && !video.paused) {
        video.pause();
      }
    });
    
    // Resetta gli iframe (YouTube/Vimeo)
    var allIframes = document.querySelectorAll('.product-gallery iframe');
    allIframes.forEach(function(iframe) {
      if (iframe.src && (iframe.src.includes('youtube') || iframe.src.includes('vimeo'))) {
        iframe.src = 'about:blank';
      }
    });
    
    // Prova a fermare anche i player Plyr (se presenti)
    if (window.Plyr) {
      var plyrPlayers = document.querySelectorAll('.plyr');
      plyrPlayers.forEach(function(player) {
        if (player.plyr && typeof player.plyr.pause === 'function') {
          player.plyr.pause();
        }
      });
    }
  }
  
  // Funzione per intercettare i clic sui pulsanti predefiniti
  function setupFixedPopupInterceptors() {
    // Trova tutti i container video nella galleria
    var videoContainers = document.querySelectorAll('.product-gallery__media[data-media-type="video"], .product-gallery__media[data-media-type="external_video"]');
    
    videoContainers.forEach(function(container) {
      // Se il container è già stato processato, saltalo
      if (container.hasAttribute('data-fixed-popup-intercepted')) {
        return;
      }
      
      // Marca il container come processato
      container.setAttribute('data-fixed-popup-intercepted', 'true');
      
      // Aggiungi un listener di intercettazione ai clic del container
      container.addEventListener('click', function(e) {
        // Non intercettare i clic sulle miniature o altri elementi di navigazione
        if (e.target.closest('.product-gallery__thumbnail')) {
          return;
        }
        
        // Apri il popup
        openFixedVideoPopup(this, e);
      }, true); // Cattura nella fase di capturing per intercettare prima che altri handler vengano eseguiti
      
      // Trova tutti i possibili pulsanti di riproduzione predefiniti
      var playButtons = container.querySelectorAll('.deferred-media__poster-button, .plyr__control--overlaid, .media__play-button, .media__poster-button, .video-control__play-button, [class*="play-button"], [class*="play_button"], [class*="poster-button"], [class*="poster_button"]');
      
      // Aggiungi intercettori a tutti i pulsanti trovati
      playButtons.forEach(function(button) {
        // Sostituisci il pulsante con un clone per rimuovere tutti gli event listener
        var newButton = button.cloneNode(true);
        if (button.parentNode) {
          button.parentNode.replaceChild(newButton, button);
        }
        
        // Aggiungi il nostro event listener al nuovo pulsante
        newButton.addEventListener('click', function(e) {
          openFixedVideoPopup(container, e);
        }, true); // Cattura nella fase di capturing
      });
    });
  }
  
  // Esegui l'inizializzazione
  setupFixedPopupInterceptors();
  
  // Monitora i cambiamenti nella galleria (per Shopify AJAX)
  if (typeof MutationObserver !== 'undefined') {
    var galleryContainer = document.querySelector('.product-gallery');
    if (galleryContainer) {
      var observer = new MutationObserver(function() {
        setupFixedPopupInterceptors();
      });
      
      observer.observe(galleryContainer, { childList: true, subtree: true });
    }
  }
  
  // Aggiungi supporto per cambi di variante
  document.addEventListener('variant:change', function() {
    setTimeout(setupFixedPopupInterceptors, 500);
  });
  
  // Esegui di nuovo dopo un po' per catturare elementi caricati in modo asincrono
  setTimeout(setupFixedPopupInterceptors, 1000);
  setTimeout(setupFixedPopupInterceptors, 3000);
});